<template>
  <ThePage :title="i18n(translations.title)">
    <template #pageTitle>
      {{ i18n(translations.title) }}
    </template>
    <template #pageContent>
      <RevTabs
        class="mb-32"
        :label="i18n(translations.tabsBarLabel)"
        role="tablist"
        scrollable
        variant="flexible"
      >
        <RevTabItem
          key="open-tasks"
          :active="isOpenTasksActive"
          :label="i18n(translations.openTasksTabTitle)"
          role="tab"
          :to="openTasksLink"
        >
          <RevBadge
            v-if="openTasksCount && openTasksCount > 0"
            :count="openTasksCount"
          />
        </RevTabItem>
        <RevTabItem
          key="all-requests"
          :active="isAllRequestsActive"
          :label="i18n(translations.allRequestsTabTitle)"
          role="tab"
          :to="allRequestsLink"
        />
      </RevTabs>

      <OpenTasks v-if="isOpenTasksActive" @update-task-count="refresh" />
      <AllRequests v-if="isAllRequestsActive" @update-task-count="refresh" />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import { sellerCustomerCareAPI } from '@backmarket/http-api'
import { useHttpLazyFetch } from '@backmarket/nuxt-module-http/useHttpLazyFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevBadge } from '@ds/components/Badge'
import { RevTabItem } from '@ds/components/TabItem'
import { RevTabs } from '@ds/components/Tabs'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './CustomerCare.translations'
import AllRequests from './components/AllRequests/AllRequests.vue'
import OpenTasks from './components/OpenTasks/OpenTasks.vue'

const i18n = useI18n()
const route = useRoute()

const openTasksLink = { name: ROUTE_NAMES.CUSTOMER_CARE.OPEN_TASKS }
const isOpenTasksActive = computed(() => route.name === openTasksLink.name)

const allRequestsLink = {
  name: ROUTE_NAMES.CUSTOMER_CARE.ALL_REQUESTS,
}
const isAllRequestsActive = computed(() => route.name === allRequestsLink.name)

const queryParams: sellerCustomerCareAPI.GetRequestsQueryParams = {
  sort: 'DEADLINE',
  pageSize: 1,
  status: 'TODO',
}

const { data: metadata, refresh } = await useHttpLazyFetch(
  sellerCustomerCareAPI.getRequests,
  {
    queryParams,
    pick: ['metadata'],
  },
)

const openTasksCount = computed(() => metadata.value?.metadata.totalCount)
</script>
